const config = {
    host: (process.env.NODE_ENV === 'production') ? 'https://taxigreen.dvgeo.app' : 'http://192.168.100.106:3035',
    homePage: (process.env.NODE_ENV === 'production') ? 'https://taxigreen.dvgeo.app' : 'http://192.168.100.106:3035',
    api: 'api/',
    apiSocket: 'taxigreen::1.2',
    nameDir: 'taxigreen',
    package: 'app.dvgeo.taxigreen.web',
    version: '1.0.3',
    googleAPIKey: 'AIzaSyDiRtCwIl3quvyA_r5rghcYeLdSt3IJ99Y',
    appName: 'TaxiGreen',
    provider: 'Devjos CIA LTDA',
    colorPrimary: '#DBA101',
    colorDark: '#131111',
    colorAccent: '#ccc',
    colorTextPrimary: '#fff',
    colorTextDark: '#000',
    playStorePassengerId: 'app.dvgeo.taxigreen.passenger',
    playStoreDriverId: 'app.dvgeo.taxigreen.driver',
    appStorePassengerId: '6443663136',
    appStoreDriverId: '6443663091',
};
export default config;
